import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { Button } from "@Components/CustomButton/Button"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import { DiagnosisState } from "@Constants/constant"
import { fetchEducationalDiagnosis } from "@Navigation/BottomTabBarStack/Logic"
import { DiagnosticEducatifContext } from "@Providers/DiagnosticEducatifProvider"
import { useIsFocused } from "@react-navigation/native"
import { currentDiagnosisAtom } from "@Recoil/Atom/DiagnosisAtom"
import { surveyResponsesAtom } from "@Recoil/Atom/surveyAtom"
import { userAtom } from "@Recoil/Atom/userAtom"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import React, { useContext, useEffect } from "react"
import { ScrollView, View } from "react-native"
import { useRecoilState } from "recoil"

const Diagnostic = ({ navigation }) => {
    const isFocused = useIsFocused()
    const [user, setUserData] = useRecoilState(userAtom)
    const { setFetchingDiagEduc } = useContext(DiagnosticEducatifContext)
    const [currentEducationalDiagnosis, setCurrentEducationalDiagnosis] = useRecoilState(currentDiagnosisAtom)
    const [responseGlobal, setSurveyResponses] = useRecoilState(surveyResponsesAtom)

    useEffect(() => {
        fetchEducationalDiagnosis({
            user,
            setLoading: setFetchingDiagEduc,
            setCurrentEducationalDiagnosis,
            handleRedirect,
            isDiagnosticScreen: true,
            handleExpiredToken: handleExpireToken
        })
    }, [isFocused])

    const gotoDiagList = () => {
        LocalStorage.saveFirstTimeDEVisitingStatus(true)
        navigation.navigate("DiagnosticEducatifList")
    }

    const handleExpireToken = () => {
        setUserData(null)
        setSurveyResponses({})
        LocalStorage.clearAll().then(() => {
            navigation.navigate("Root", { screen: "RegisterLoginStack" })
        })
    }

    const handleRedirect = () => {
        if (currentEducationalDiagnosis?.diagnosisStatus?.code === DiagnosisState.READY) {
            navigation.navigate("DiagnosticConclusion")
        } else {
            const redirectToList =
                currentEducationalDiagnosis?.diagnosisStatus?.id > 0 || Object.keys(responseGlobal).length > 0

            // if (redirectToList) {
            //     gotoDiagList()
            // } else {
            navigation.navigate("DiagnosticStack")
            // }
        }
    }

    return (
        <ContainerStackScreen>
            <View style={{ paddingVertical: 20 }}>
                <BreeSerifText fontSize={22} color={baseColors.green.primary}>
                    Diagnostic Éducatif
                </BreeSerifText>
            </View>

            <ScrollView
                keyboardShouldPersistTaps={"handled"}
                showsVerticalScrollIndicator={false}
                contentContainerStyle={{ paddingBottom: 100 }}
            >
                <Spacer />

                <OpenSansText fontSize={14}>
                    Le Diagnostic Éducatif permettra de déterminer vos besoins avec un professionnel et de personnaliser
                    le contenu et les activités qui vous seront accessibles depuis l'application.
                </OpenSansText>

                <Spacer />

                <OpenSansText fontSize={14} textAlign={"justify"}>
                    Le Diagnostic Éducatif nécessite de répondre à un questionnaire autour de 4 axes puis de planifier
                    un échange avec les soignants de l'équipe IVEHTE.
                </OpenSansText>
                <Spacer height={40} />
                <OpenSansText fontSize={14} fontStyle={"italic"}>
                    Vos données restent confidentielles et ne seront partagées qu'avec les soignants de l’équipe IVEHTE.
                </OpenSansText>
                <View style={{ height: 30 }} />
            </ScrollView>

            <Button
                onPress={() => gotoDiagList()}
                text="Suivant"
                width="80%"
                backgroundColor={baseColors.green.primary}
                labelColor={"white"}
                marginTop={10}
                marginBottom={10}
            />
        </ContainerStackScreen>
    )
}

export default Diagnostic
